import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dhule-dist-badminton-championship',
  templateUrl: './dhule-dist-badminton-championship.component.html',
  styleUrls: ['./dhule-dist-badminton-championship.component.scss']
})
export class DhuleDistBadmintonChampionshipComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
